;(function( window, document, $, undefined ) {
	'use strict';

	// Content Highlights

	function contentHighlights() {

    // Add classes
    function addClasses( $target ) {
      $('.block-content-highlights .content-highlights').eq(0).addClass('first');
      $('.block-content-highlights .content-highlights').eq(1).addClass('second');
      $('.block-content-highlights .content-highlights').eq(2).addClass('third');
    }

    // Adjustments in Width
    function adjustmentsWidth( $el, $target ) {

      var counter = 0;
      $('.block-content-highlights .content-highlights .wpb_wrapper').each(function(){
        var $this = $(this);
        if( $this.outerWidth() > counter ) {
          counter = $this.outerWidth();
        }
      });
      $('.block-content-highlights .content-highlights .wpb_wrapper').css('width',counter + 5);
    }

		// Globals
		return {
      addClasses: addClasses,
      adjustmentsWidth : adjustmentsWidth
		};

	}

	// Globals
	window.callsource = window.callsource || {};
  window.callsource.contentHighlights = contentHighlights();

})( window, document, jQuery );
